import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-2.5 px-3 rounded-lg shadow-lg" }
const _hoisted_2 = { class: "flex justify-between mt-1 h-7" }
const _hoisted_3 = { class: "overflow-hidden text-lg whitespace-nowrap overflow-ellipsis" }
const _hoisted_4 = { class: "flex justify-between h-6 mt-2" }
const _hoisted_5 = { class: "overflow-hidden text-xs text-gray-400 overflow-ellipsis whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.lesson.name), 1),
      _createElementVNode("div", null, _toDisplayString(_ctx.lesson.codeFull), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.lesson.teachers.join(' ')), 1),
      _createElementVNode("div", null, _toDisplayString(_ctx.lesson.semester), 1)
    ])
  ]))
}